import React from 'react';

import './footer.scss';

export const Footer = (sec) => (
    <footer>
        <h1>
            ABC Tree Service
        </h1>
        <h2>
            Natural pruning only to benefit trees - Shape life and balance
        </h2>
        <br></br>
        <h2>
            Free estimates
        </h2>
        <h2>
            Call us: <a href="tel:4088387430">408-838-7430</a>
        </h2>
        <h2>
            Email us: <a href="mailto:abctrees@yahoo.com">abctrees@yahoo.com</a>
        </h2>
        <br/>
        <h2>
            10045 Monterey Rd Gilroy, CA 95020
        </h2>
    </footer>
)
  
  
